/**
 * Application configuration constants
 */

export const WEB3FORMS_ACCESS_KEY = 'f647a90f-d081-4109-8a6a-5551e9a1902d';
